import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@img/icon-tips.png'


const _withScopeId = n => (_pushScopeId("data-v-2359dc5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "queue-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "queue-content" }
const _hoisted_4 = { class: "queue-mode-box" }
const _hoisted_5 = { class: "queue-mode" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "user-gold" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "wait-times" }
const _hoisted_12 = { class: "price" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "queue-mode" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "user-gold" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "wait-times" }
const _hoisted_21 = { class: "price" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "speed-card" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "card" }
const _hoisted_26 = ["src"]
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "user-gold" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "wait-times" }
const _hoisted_31 = { class: "price" }
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vip-card" }, "Active VIP", -1))
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 0,
  class: "in-queue"
}
const _hoisted_36 = { class: "inner-box" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "In the queue", -1))
const _hoisted_38 = ["src"]
const _hoisted_39 = {
  key: 1,
  class: "start-queue"
}
const _hoisted_40 = ["src"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Connecting to cloud server")
], -1))

import { ref, computed, onBeforeUnmount, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { Tooltip } from "ant-design-vue";

import { usePlayGameStore } from "@/store/playGame";
import { useGameListStore } from "@/store/gameList";
import { useloginStore } from "@/store/login";
import pb from "@pb/index.json";
import BusinessManager from "@js/controls";
import * as Account from "@js/account";
import { getSpeedCardId, getVipGoodsId } from "@/config";
import AppSvga from "@/components/AppSvga/index.vue";
import { apiGetVipPageInfo } from "@/api/login";
import CusModal from "@/components/CusModal/index.vue";
import IPCCenter from "@js/ipc";
import { EVENTCMD } from "@js/events";
import { IStateType } from "@/js/game/state/IGameState";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const yunpb = pb.nested.yunpb.nested;
const PLAYERSTATUS = yunpb.PlayerStatus.values;
const QueueType = yunpb.QueueType.values;
const AutoUsePriorityType = yunpb.AutoUsePriorityType.values;

const playGameStore = usePlayGameStore();
const gameListStore = useGameListStore();
const loginStore = useloginStore();
const floatModal = computed(() => playGameStore.floatModal);
const queueData = computed(() => playGameStore.queueData);
const router = useRouter();

const countDown = computed(() => queueData.value?.countDown);
const roomInfo = computed(() => playGameStore.roomInfo);
// 排队队列数据
const queueList = computed(() => [
  {
    level: yunpb.QueueLevel.values.QL_Normal,
    data: roomInfo.value?.normalWaitingNode,
  },
  {
    level: yunpb.QueueLevel.values.QL_Fast,
    data: roomInfo.value?.newPayWaitingNode,
  },
  {
    level: yunpb.QueueLevel.values.QL_Vip,
    data: roomInfo.value?.vipWaitingNode,
  },
]);
const queueLevel = computed(
  () =>
    roomInfo.value?.queueInfo?.queueLevel || yunpb.QueueLevel.values.QL_Normal
);
const gameName = computed(() => {
  return roomInfo.value?.gameBaseInfo?.gameName || "";
});

const countTime = ref(15);
const timer = ref<any>(0);
const isCanceling = ref(false);
const speedCard = ref(0);
const isMiss = ref(false);
const isCancelQueue = ref(false);

const isLoading = computed(() => {
  return playGameStore.queueData?.playerOper === PLAYERSTATUS.IN_QUE;
});
const isShow = computed(() => {
  return playGameStore.queueModal;
});

watch([isShow, floatModal], ([newShow], [oldShow, oldFloatModal]) => {
  if (newShow && !oldFloatModal) {
    fetchGetBagItems();
  }
});

const fetchGetBagItems = async () => {
  const res: any = await BusinessManager.CltGetBagItems();
  console.log(res, "CltGetBagItems");

  if (res && res.code === 0) {
    speedCard.value = res.obj?.speedCard || 0;
  }
};

// 立即进入游戏
const handleOk = () => {
  clearInterval(timer.value);
  // playGameStore.handleOpenGame();
  window.gameStateMgr.playGame();
};
// 放弃进入游戏
const handleCancel = async () => {
  isCanceling.value = true;
  // await playGameStore.handleCancelBackGame();
  // 等待进入状态 直接退出游戏
  window.gameStateMgr.exitGame();
  clearInterval(timer.value);
  isCanceling.value = false;
};
// 关闭弹框，逛一逛
const handleBack = () => {
  playGameStore.showFloatModal({});
};

const handleConfirmMiss = () => {
  isMiss.value = false;
};

const handleChangeCancelRequeue = (show: boolean) => {
  isCancelQueue.value = show;
};

// 取消排队
const handleConfirmLeave = () => {
  handleChangeCancelRequeue(false);
  // playGameStore.handleCancelQueue();
  // 排队状态取消排队
  window.gameStateMgr.exitGame();
};

const handleUseSpeedCard = async () => {
  await fetchGetBagItems();
  if (!speedCard.value) {
    await handleShowBuyGoodsModal({
      goodsId: getSpeedCardId(),
      kind: yunpb.GoodsPaymentWayKind.values.GPWK_OrderGoods,
    });
    return;
  }
  const res: any = await BusinessManager.CltUseQueueCardReq(
    yunpb.QueueCardType.values.QCT_SpeedUp
  );
  console.log(res, "CltUseQueueCardReq");

  if (res && res.code === 0) {
    speedCard.value -= res.obj.speedCardUseNum;
    playGameStore.handleRefreshQueuePanel(res.obj);
  }
};

const handleShowBuyGoodsModal = async ({
  goodsId,
  kind,
}: {
  goodsId: number;
  kind: number;
}) => {
  gameListStore.update_isShowBuyGoodModal({
    isShow: true,
    goodsId,
    kind,
  });
};

const handleUseVipQueue = async () => {
  //非会员跳转到会员页面
  console.log("login info", loginStore.userInfo);
  if (!loginStore.userInfo.vipInfo.vipLevelType) {
    router.push({ name: "VIP" });
    return;
  }
  if (queueLevel.value === queueList.value[2].level) {
    return;
  }

  const res: any = await apiGetVipPageInfo({});
  const isViper = res?.vipInfo?.vipLevelType > 0;

  // 开通vip后会默认进入 vip 队列
  if (isViper) {
    return;
  }

  handleShowBuyGoodsModal({
    goodsId: getVipGoodsId(),
    kind: yunpb.GoodsPaymentWayKind.values.GPWK_OrderGoods,
  });
};

// // 使用推送消息启动倒计时
IPCCenter.getInstance().addListener(EVENTCMD.StartCountDown, () => {
  console.log("使用推送消息启动倒计时", countDown.value);

  clearInterval(timer.value);
  countTime.value = countDown?.value || 15;
  timer.value = setInterval(() => {
    const currentState = Number(localStorage.getItem("CURRENTSTATE"));
    if (currentState === IStateType.CAN_RETURN_GAME) {
      console.log("StartCountDown");
      IPCCenter.getInstance().broadCastEvent(
        EVENTCMD.SetCurrentGameState,
        IStateType.CAN_RETURN_GAME
      );
      playGameStore.showFloatModal({ playerOper: PLAYERSTATUS.NO_OPER });
      clearInterval(timer.value);
      return;
    }
    if (countTime.value > 0) {
      countTime.value--;
    }

    if (countTime.value <= 0) {
      // 倒计时结束，切换状态为错过进入游戏
      // window.gameStateMgr.setState(IStateType.MISS_ENTER_GAME);
      IPCCenter.getInstance().broadCastEvent(
        EVENTCMD.SetCurrentGameState,
        IStateType.MISS_ENTER_GAME
      );
      handleCancel();
      isMiss.value = true;
    }
  }, 1000);
});

onBeforeUnmount(() => {
  console.log("队列面板卸载，清除定时器");
  clearInterval(timer.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CusModal, {
      width: "771px",
      centered: "",
      isShow: _unref(isShow),
      closable: false,
      keyboard: false,
      bodyStyle: { padding: 0 },
      maskClosable: _unref(isLoading),
      class: "queue-control-dialog",
      onOnClose: handleBack
    }, {
      default: _withCtx(() => [
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("img", {
                class: "post",
                src: require('@/assets/img/img-post.png'),
                alt: ""
              }, null, 8, _hoisted_2),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", {
                        class: "speed-type",
                        src: require('@/assets/img/icon-slow.png'),
                        alt: ""
                      }, null, 8, _hoisted_7),
                      (_unref(queueLevel) === _unref(queueList)[0].level)
                        ? (_openBlock(), _createBlock(AppSvga, {
                            key: 0,
                            class: "badge-type",
                            src: require('@/assets/img/anim-normal.svga')
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            class: "badge-type",
                            src: require('@/assets/img/img-badge-normal.png'),
                            alt: ""
                          }, null, 8, _hoisted_8)),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("img", {
                          src: require('@/assets/img/icon-user-normal.png'),
                          alt: ""
                        }, null, 8, _hoisted_10),
                        _createElementVNode("span", null, _toDisplayString(_unref(queueList)[0].data?.num > 9999
                      ? "9999+"
                      : _unref(queueList)[0].data?.num), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(queueList)[0].data?.desc), 1),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("img", {
                          src: require('@/assets/img/icon-gold.png'),
                          alt: ""
                        }, null, 8, _hoisted_13),
                        _createElementVNode("span", null, _toDisplayString((_unref(queueList)[0].data?.optGoldInfo?.gold &&
                      _unref(queueList)[0].data?.optGoldInfo?.gold + "/min") ||
                    "--"), 1)
                      ])
                    ]),
                    (_unref(queueLevel) === _unref(queueList)[0].level)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "active-arrow",
                          src: require('@/assets/img/icon-active.png'),
                          alt: ""
                        }, null, 8, _hoisted_14))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", {
                      class: "card",
                      onClick: handleUseSpeedCard
                    }, [
                      _createElementVNode("img", {
                        class: "speed-type",
                        src: require('@/assets/img/icon-fast.png'),
                        alt: ""
                      }, null, 8, _hoisted_16),
                      (_unref(queueLevel) === _unref(queueList)[1].level)
                        ? (_openBlock(), _createBlock(AppSvga, {
                            key: 0,
                            class: "badge-type",
                            src: require('@/assets/img/anim-fast.svga')
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            class: "badge-type",
                            src: require('@/assets/img/img-badge-fast.png'),
                            alt: ""
                          }, null, 8, _hoisted_17)),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("img", {
                          src: require('@/assets/img/icon-user-fast.png'),
                          alt: ""
                        }, null, 8, _hoisted_19),
                        _createElementVNode("span", null, _toDisplayString(_unref(queueList)[1].data?.num > 9999
                      ? "9999+"
                      : _unref(queueList)[1].data?.num), 1)
                      ]),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(queueList)[1].data?.desc), 1),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("img", {
                          src: require('@/assets/img/icon-gold.png'),
                          alt: ""
                        }, null, 8, _hoisted_22),
                        _createElementVNode("span", null, _toDisplayString((_unref(queueList)[1].data?.optGoldInfo?.gold &&
                      _unref(queueList)[1].data?.optGoldInfo?.gold + "/min") ||
                    "--"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, "Speed Card *" + _toDisplayString(speedCard.value), 1)
                    ]),
                    (_unref(queueLevel) === _unref(queueList)[1].level)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "active-arrow",
                          src: require('@/assets/img/icon-active.png'),
                          alt: ""
                        }, null, 8, _hoisted_24))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: "queue-mode",
                    onClick: handleUseVipQueue
                  }, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("img", {
                        class: "speed-type",
                        src: require('@/assets/img/icon-vip.png'),
                        alt: ""
                      }, null, 8, _hoisted_26),
                      (_unref(queueLevel) === _unref(queueList)[2].level)
                        ? (_openBlock(), _createBlock(AppSvga, {
                            key: 0,
                            class: "badge-type",
                            src: require('@/assets/img/anim-vip.svga')
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            class: "badge-type",
                            src: require('@/assets/img/img-badge.png'),
                            alt: ""
                          }, null, 8, _hoisted_27)),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("img", {
                          src: require('@/assets/img/icon-user-vip.png'),
                          alt: ""
                        }, null, 8, _hoisted_29),
                        _createElementVNode("span", null, _toDisplayString(_unref(queueList)[2].data?.num > 9999
                      ? "9999+"
                      : _unref(queueList)[2].data?.num), 1)
                      ]),
                      _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(queueList)[2].data?.desc), 1),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("img", {
                          src: require('@/assets/img/icon-gold.png'),
                          alt: ""
                        }, null, 8, _hoisted_32),
                        _createElementVNode("span", null, _toDisplayString((_unref(queueList)[2].data?.optGoldInfo?.gold &&
                      _unref(queueList)[2].data?.optGoldInfo?.gold + "/min") ||
                    "--"), 1)
                      ]),
                      _hoisted_33
                    ]),
                    (_unref(queueLevel) === _unref(queueList)[2].level)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "active-arrow",
                          src: require('@/assets/img/icon-active.png'),
                          alt: ""
                        }, null, 8, _hoisted_34))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_unref(playGameStore).isQueueing)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("img", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChangeCancelRequeue(true))),
                          class: "cancle-queue",
                          src: require('@/assets/img/icon-close.png'),
                          alt: ""
                        }, null, 8, _hoisted_38)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createElementVNode("span", null, _toDisplayString(_unref(gameName)), 1),
                      _withDirectives(_createElementVNode("span", null, [
                        _createTextVNode(" （"),
                        _createElementVNode("img", {
                          src: require('@/assets/img/icon-gold.png'),
                          alt: ""
                        }, null, 8, _hoisted_40),
                        _createTextVNode(" " + _toDisplayString(`${_unref(queueList)?.[_unref(queueLevel)].data?.optGoldInfo?.gold}/min`) + "） ", 1)
                      ], 512), [
                        [_vShow, _unref(queueList)?.[_unref(queueLevel)].data?.optGoldInfo?.gold]
                      ])
                    ])),
                _createVNode(_unref(Tooltip), null, {
                  title: _withCtx(() => [
                    _createTextVNode("Chikii platform only provides cloud services,allthe game resources are shared by users or the internet")
                  ]),
                  default: _withCtx(() => [
                    _hoisted_41
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isShow", "maskClosable"]),
    _createVNode(CusModal, {
      isShow: !_unref(isLoading) && _unref(isShow),
      title: "Queue successfully, enter the game?",
      content: `Give up automatically after ${countTime.value} seconds.`,
      onOnCancel: handleCancel,
      onOnClose: handleCancel,
      onOnConfirm: handleOk,
      cancelText: "Give up",
      okText: "Enter immediately"
    }, null, 8, ["isShow", "content"]),
    _createVNode(CusModal, {
      isShow: isMiss.value,
      title: "Tips",
      content: `You missed the line.`,
      onOnCancel: handleConfirmMiss,
      onOnClose: handleConfirmMiss,
      onOnConfirm: handleConfirmMiss,
      okText: "OK"
    }, null, 8, ["isShow", "content"]),
    _createVNode(CusModal, {
      isShow: isCancelQueue.value,
      title: "Tips",
      content: `There are ${
      _unref(queueList)?.[_unref(queueLevel)]?.data?.num || 2
    } people in front of you.confirm to leave?`,
      onOnCancel: _cache[1] || (_cache[1] = ($event: any) => (handleChangeCancelRequeue(false))),
      onOnClose: _cache[2] || (_cache[2] = ($event: any) => (handleChangeCancelRequeue(false))),
      onOnConfirm: handleConfirmLeave,
      okText: "OK"
    }, null, 8, ["isShow", "content"])
  ], 64))
}
}

})